import { EmployeeProfileRoleDto } from '@/api/generated';
import { RolesDictionariesTranslation } from '@/assets/locales/dictionaries/roles/roles.dictionaries.pl.ts';

export const rolesDictionariesTranslation: RolesDictionariesTranslation = {
  [EmployeeProfileRoleDto.Admin]: 'Administrator',
  [EmployeeProfileRoleDto.AdminDevelopment]: 'Development Administrator',
  [EmployeeProfileRoleDto.AdminSuccession]: 'Succession Administrator',
  [EmployeeProfileRoleDto.ForceAccess]: 'Force access',
  [EmployeeProfileRoleDto.HqHrbp]: 'HQ HRBP',
  [EmployeeProfileRoleDto.Hrbp]: 'HRBP',
  [EmployeeProfileRoleDto.NoAccess]: 'No access',
  [EmployeeProfileRoleDto.Owner]: 'Owner',
  [EmployeeProfileRoleDto.P1]: 'Manager',
  [EmployeeProfileRoleDto.P2]: 'P2 Manager',
};
